// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
//@core
const { formatText } = require('core/i18n').i18n;
// @components
const ContractLoanTooltip = require('../../contractLoanTooltip/contractLoanTooltip');
const ContractLoanCompilationCard = require('../../contractLoanCompilationCard/contractLoanCompilationCard');
//@utilities
const { getFormattedString, formatCurrency, formatAmount, decimalsLength } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { mapContractingData, mapTotalCostInfo } = require('../contractAresLoanHelper');
// @constants
const ARES_CONTEXT = "aresLoan-";
const BASE_CONTEXT = `${ARES_CONTEXT}mbBanking.products.loansAndMortgages.productContracting.aresLoanContracting.mbAresLoanContracting.`;

class ContractAresLoanSidebar extends React.Component {

  buildAccount() {
        const { selectedAccount } = this.props;
        const accountAlias = selectedAccount.get('alias');
        const accountIban = getLastNChars(selectedAccount.get('iban'));
        const accountBalance = getFormattedString(selectedAccount.get('balance'));

        return [
            {
                label: formatText('payrollLoanCompilationCard-associatedAccount'),
                text: `${accountAlias} ${accountIban}`,
                className: 'payroll-loan-compilation-card__list-separator'
            },
            {
                label: formatText('payrollLoanCompilationCard-accountBalance'),
                text: `${accountBalance}`
            }
        ];
    }

    buildFooterList() {
        const { selectedAccount, paymentDayType } = this.props;
        const contractingData = mapContractingData(this.props.contractingData, paymentDayType);
        const currency = formatCurrency(contractingData.get('currency'));
        const arrangementPercentage = formatAmount(contractingData.get('arrangementPercentage'));
        const arrangementFee = contractingData.get('arrangementFee');
        const totalAmount = getFormattedString({
            amount: contractingData.get('totalAmount'),
            currency: contractingData.get('currency'),
            decimalsLength: decimalsLength(contractingData.get('totalAmount')),
        });
        
        let list = [{
            label: formatText('payrollLoanCompilationCard-openingCommission', [arrangementPercentage]),
            text: `${arrangementFee} ${currency}`,
            additionalLabel: (<sup>1</sup>),
        }, {
            label: formatText(`${BASE_CONTEXT}totalAmountLabel`),
            text: totalAmount,
            icon: 'icon-informacion',
            tooltipPlacement: 'right',
            tooltipModifier: 'dark-bg',
            tooltipAlternativeIcon: true,
            tooltipClassName: 'contract-ares-loan-step-one__tooltip',
            iconCustomClass: 'contract-ares-loan-step-one__tae-icon',
            tooltipOffset: [10, 0],
            information: formatText(`${BASE_CONTEXT}totalAmountTooltip`, [mapTotalCostInfo(this.props.contractingData, paymentDayType)]),
        }];

        if (selectedAccount) {
            list = list.concat(this.buildAccount());
        }

        return list;
    }

    buildTaeTooltip() {
        const { contractingData, paymentDayType } = this.props;

        return (
            <ContractLoanTooltip
                immContractLoan={mapContractingData(contractingData, paymentDayType)}
                clarifyingText="clarifyingText"
            />
        );
    }

    render() {
        const { contractingData, paymentDayType } = this.props;
        const taeTooltip = this.buildTaeTooltip();
        const footerList = this.buildFooterList();

        return (
            <ContractLoanCompilationCard
                immSummary={mapContractingData(contractingData, paymentDayType)}
                taeTooltip={taeTooltip}
                footerList={footerList}
            />
        );
    }
}

ContractAresLoanSidebar.propTypes = {
    selectedAccount: PropTypes.object,
    contractingData: PropTypes.object.isRequired,
    paymentDayType: PropTypes.string.isRequired,
};

module.exports = ContractAresLoanSidebar;
